import { successMessage } from '@/utils/message.js';
import PurchaseBusinessService from '../../purchase-business-service';
import previewEngineeringContract from '../../purchase-project/preview-engineering-contract/index.vue';
import previewServiceContract from '../../purchase-project/preview-service-contract/index.vue';

export default {
  components: {
    previewEngineeringContract,
    previewServiceContract
  },
  data() {
    return {
      dialogFormVisible: false,
      preview: {},
      fundsInfo: {},
      purchaseInfo: {},
      userInfo: {},
      form: {
        purchaseId: 0,
        confirmStatus: true
      },
      ruleForm: {
        refuseReason: ''
      },
      rules: {
        refuseReason: [
          { required: true, message: '请输入少于100的退回修改原因', trigger: 'change' }
        ]
      }
    };
  },
  created() {
    this.id = this.$route.query.id;
    this.form.purchaseId = parseInt(this.id);
    PurchaseBusinessService.getContractDetailP(this.id).then(res => {
      if(res.code === '0'){
        this.preview = res.data;
        this.fundsInfo = JSON.parse(res.data.fundsInfo);
      }
    });
  },
  computed: {
  },
  filters: {
    percentage: function (value) {
      if (!value) return '0‰';
      return value.toFixed(2) + '‰';
    }
  },
  methods: {
    // 返回
    goBack(){
      this.$router.back();
    },
    dialogFormclick() {
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$confirm('确定要退回合同让采购人修改？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.submit();
          }).catch(() => {
          });
        } else {
          return false;
        }
      });
    },
    // 退回修改
    submit() {
      let params = {
        refuseReason: this.ruleForm.refuseReason
      };
      this.form.confirmStatus = false;
      PurchaseBusinessService.confirmPurchaseContract(this.form.purchaseId, this.form.confirmStatus, params).then(res => {
        if(res.code === '0'){
          successMessage('退回成功');
          this.dialogFormVisible = false;
          this.$router.back();
        }
      }).catch(() => {
        this.dialogFormVisible = false;
      });
    },
    // 驳回修改
    goRreject(){
      this.form.confirmStatus = false;
      this.$confirm('确定要退回合同让采购人修改？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.confirmPurchaseContract(this.form.purchaseId, this.form.confirmStatus).then(res => {
          if(res.code === '0'){
            successMessage('退回成功');
            this.$router.back();
          }
        });
      }).catch(() => {});
    },
    // 提交合同
    goPost(){
      this.form.confirmStatus = true;
      this.$confirm('确定要提交吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        PurchaseBusinessService.confirmPurchaseContract(this.form.purchaseId, this.form.confirmStatus).then(res => {
          if(res.code === '0'){
            successMessage('提交成功');
            this.$router.back();
          }
        });
      }).catch(() => {});
    }
  }
};
